import React from 'react';

import { ArrowRight } from '../../assets/Icons';

const ExternalLinkIcon: React.FC = () => (
  <ArrowRight className="ml-1 inline h-4 w-4 -rotate-45 transform transition group-hover:-translate-y-px group-hover:translate-x-px" />
);

export default ExternalLinkIcon;
